import imageRain from './assets/Images/rain.png';
import soundRain from './assets/Sounds/rain.mp3';
import imageFire from './assets/Images/fire.png';
import soundFire from './assets/Sounds/fire.mp3';
import imageForest from './assets/Images/forest.png';
import soundForest from './assets/Sounds/forest.mp3';
import imageWave from './assets/Images/wave.png';
import soundWave from './assets/Sounds/wave.mp3';
import imageBirds from './assets/Images/birds.png';
import soundBirds from './assets/Sounds/birds.mp3';
import imageCrickets from './assets/Images/crickets.png';
import soundCrickets from './assets/Sounds/crickets.mp3';
import imageWind from './assets/Images/wind.png';
import soundWind from './assets/Sounds/wind.mp3';
import imageGuitar from './assets/Images/guitar.png';
import soundGuitar from './assets/Sounds/guitar.mp3';
import imageWhale from './assets/Images/whale.png';
import soundWhale from './assets/Sounds/whale.mp3';
import imagePiano from './assets/Images/piano.png';
import soundPiano from './assets/Sounds/piano.mp3';
import imageBowl from './assets/Images/bowls.png';
import soundBowl from './assets/Sounds/bowls.mp3';
import imageFrog from './assets/Images/frog.png';
import soundFrog from './assets/Sounds/frog.mp3';

const ambiances = [
    {
      id: 1,
      name: "Waves",
      imageUrl: imageWave,
      audioUrl: soundWave //
    },
    {
      id: 2,
      name: "Forest",
      imageUrl: imageForest,
      audioUrl: soundForest
    },
    {
      id: 3,
      name: "Rain",
      imageUrl: imageRain,
      audioUrl: soundRain
    },
    {
      id: 4,
      name: "Fireplace",
      imageUrl: imageFire,
      audioUrl: soundFire
    },
    {
      id: 5,
      name: "Birds",
      imageUrl: imageBirds,
      audioUrl: soundBirds
    },
    {
      id: 6,
      name: "Crickets",
      imageUrl: imageCrickets,
      audioUrl: soundCrickets
    },
    {
      id: 7,
      name: "Wind",
      imageUrl: imageWind,
      audioUrl: soundWind
    },
    {
      id: 8,
      name: "Guitar",
      imageUrl: imageGuitar,
      audioUrl: soundGuitar
    },
    {
      id: 9,
      name: "Whale",
      imageUrl: imageWhale,
      audioUrl: soundWhale
    },
    {
      id: 10,
      name: "Tibetan Bowl",
      imageUrl: imageBowl,
      audioUrl: soundBowl
    },
    {
      id: 11,
      name: "Piano",
      imageUrl: imagePiano,
      audioUrl: soundPiano
    },
    {
      id: 12,
      name: "Frog",
      imageUrl: imageFrog,
      audioUrl: soundFrog
    }
  ];
  
  export default ambiances;
  